export const SET_WINDOW_INNER_WIDTH = 'SET_WINDOW_INNER_WIDTH';

export const SET_USER_AUTHENTICATED = 'SET_USER_AUTHENTICATED';
export const SET_USER_ROLES = 'SET_USER_ROLES';
export const SET_IS_LOGIN = 'SET_IS_LOGIN';
export const SET_IS_LOGGED_IN = 'SET_IS_LOGGED_IN';
export const LOGOUT = 'LOGOUT';
export const SET_IS_ONLINE = 'SET_IS_ONLINE';

// 頁面尚未儲存的阻擋提示
export const SET_IS_SURVEY_FORM_EDIT_SAVED_NOT_YET = 'SET_IS_SURVEY_FORM_EDIT_SAVED_NOT_YET';
export const SET_IS_INDEX_PAGE_EDIT_SAVED_NOT_YET = 'SET_IS_INDEX_PAGE_EDIT_SAVED_NOT_YET';
export const SET_IS_BADGE_EDIT_SAVED_NOT_YET = 'SET_IS_BADGE_EDIT_SAVED_NOT_YET';

export const SWITCH_EVENT = 'SWITCH_EVENT';
// Event 首頁的動作與設定收合
export const SET_IS_SHOW_PRIOR_SETTING_BLOCK = 'SET_IS_SHOW_PRIOR_SETTING_BLOCK';
// List 的注意事項收合
export const SET_LIST_NOTICE_SHOW = 'SET_LIST_NOTICE_SHOW';
// SMS 編輯的說明與範例收合
export const SET_IS_OPENED_SMS_EDIT_INSTRUCTION_PANEL = 'SET_IS_OPENED_SMS_EDIT_INSTRUCTION_PANEL';

// Email、cell phone 格式檢查
export const SET_IS_EMAIL_FORMAT_CHECKED = 'SET_IS_EMAIL_FORMAT_CHECKED';
export const SET_IS_CELL_PHONE_FORMAT_CHECKED = 'SET_IS_CELL_PHONE_FORMAT_CHECKED';

// 各種提示訊息是否隱藏
export const SET_IS_HIDDEN_RIGHT_BOTTOM_HINT = 'SET_IS_HIDDEN_RIGHT_BOTTOM_HINT';
export const SET_IS_HIDDEN_EMAIL_TEMPLATE_HINT = 'SET_IS_HIDDEN_EMAIL_TEMPLATE_HINT';
export const SET_IS_HIDDEN_HEALTH_FORM_HINT = 'SET_IS_HIDDEN_HEALTH_FORM_HINT';
export const SET_IS_HIDDEN_BADGE_HINT = 'SET_IS_HIDDEN_BADGE_HINT';
export const SET_IS_HIDDEN_TUTORIAL_TAB_HINT = 'SET_IS_HIDDEN_TUTORIAL_TAB_HINT';

// 第一次造訪平台
export const SET_IS_VISIT_FIRST_TIME = 'SET_IS_VISIT_FIRST_TIME';

// 不顯示標籤機租用資訊 toast
export const SET_IS_NOT_BADGE_LABEL_MACHINE_RENT_INFORMATION_SHOWN =
  'SET_IS_NOT_BADGE_LABEL_MACHINE_RENT_INFORMATION_SHOWN';

// 初始化所有 store states
export const INITIALIZE_ALL_STATES = 'INITIALIZE_ALL_STATES';

// 初始化設定的 reducer 的 state
export const INITIALIZE_STATES_FULFILLED = 'INITIALIZE_STATES_FULFILLED';

// set language
export const SET_USER_LANGUAGE = 'SET_USER_LANGUAGE';

// 設定 server timestamp
export const SET_SYSTEM_TIMESTAMP = 'SET_SYSTEM_TIMESTAMP';
export const SET_IS_MAINTENANCE = 'SET_IS_MAINTENANCE';

// 導覽的當前 KEY
export const POST_TUTORIALS_ACTIVE_KEY = 'POST_TUTORIALS_ACTIVE_KEY';

// GET 是否第一次使用
export const IS_DONE_FIRST_TIME = 'IS_DONE_FIRST_TIME';
export const GET_IS_DONE_FIRST_TIME_PENDING = 'GET_IS_DONE_FIRST_TIME_PENDING';
export const GET_IS_DONE_FIRST_TIME_FULFILLED = 'GET_IS_DONE_FIRST_TIME_FULFILLED';
export const GET_IS_DONE_FIRST_TIME_FAILURE = 'GET_IS_DONE_FIRST_TIME_FAILURE';

/* modal visible */
// 建立活動 modal visible
export const SET_CREATING_EVENT_MODAL_VISIBLE = 'SET_CREATING_EVENT_MODAL_VISIBLE';
/* modal visible */

// 註冊驗證信
export const POST_REGISTER_AUTHENTICATED_PENDING = 'POST_REGISTER_AUTHENTICATED_PENDING';
export const POST_REGISTER_AUTHENTICATED_FULFILLED = 'POST_REGISTER_AUTHENTICATED_FULFILLED';
export const POST_REGISTER_AUTHENTICATED_FAILURE = 'POST_REGISTER_AUTHENTICATED_FAILURE';

// 重發驗證信
export const RESEND_REGISTER_AUTHENTICATED_PENDING = 'RESEND_REGISTER_AUTHENTICATED_PENDING';
export const RESEND_REGISTER_AUTHENTICATED_FULFILLED = 'RESEND_REGISTER_AUTHENTICATED_FULFILLED';
export const RESEND_REGISTER_AUTHENTICATED_FAILURE = 'RESEND_REGISTER_AUTHENTICATED_FAILURE';

// 忘記密碼重設
export const RESET_NEW_PASSWORD = 'RESET_NEW_PASSWORD';

// 註冊
export const POST_REGISTER_PENDING = 'POST_REGISTER_PENDING';
export const POST_REGISTER_FULFILLED = 'POST_REGISTER_FULFILLED';
export const POST_REGISTER_FAILURE = 'POST_REGISTER_FAILURE';

// 檢查註冊帳號可否使用
export const CHECK_REPEAT_ACCOUNT_PENDING = 'CHECK_REPEAT_ACCOUNT_PENDING';
export const CHECK_REPEAT_ACCOUNT_FULFILLED = 'CHECK_REPEAT_ACCOUNT_FULFILLED';
export const CHECK_REPEAT_ACCOUNT_FAILURE = 'CHECK_REPEAT_ACCOUNT_FAILURE';

// 檢查登入
export const CHECK_LOGIN_PENDING = 'CHECK_LOGIN_PENDING';
export const CHECK_LOGIN_FULFILLED = 'CHECK_LOGIN_FULFILLED';
export const CHECK_LOGIN_FAILURE = 'CHECK_LOGIN_FAILURE';

// 檢查 token 期限
export const CHECK_TOKEN_EXPIRED_PENDING = 'CHECK_TOKEN_EXPIRED_PENDING';
export const CHECK_TOKEN_EXPIRED_FULFILLED = 'CHECK_TOKEN_EXPIRED_FULFILLED';
export const CHECK_TOKEN_EXPIRED_FAILURE = 'CHECK_TOKEN_EXPIRED_FAILURE';

// 忘記密碼發送重設密碼信件
export const SEND_FORGOT_PASSWORD_EMAIL_PENDING = 'SEND_FORGOT_PASSWORD_EMAIL_PENDING';
export const SEND_FORGOT_PASSWORD_EMAIL_FULFILLED = 'SEND_FORGOT_PASSWORD_EMAIL_FULFILLED';
export const SEND_FORGOT_PASSWORD_EMAIL_FAILURE = 'SEND_FORGOT_PASSWORD_EMAIL_FAILURE';

// 重設密碼
export const RESET_NEW_PASSWORD_PENDING = ' RESET_NEW_PASSWORD_PENDING';
export const RESET_NEW_PASSWORD_FULFILLED = ' RESET_NEW_PASSWORD_FULFILLED';
export const RESET_NEW_PASSWORD_FAILURE = ' RESET_NEW_PASSWORD_FAILURE';

// -------------- device -------------------
// logut device code
export const GET_DISUSE_DEVICE_CODE_PENDING = 'GET_DISUSE_DEVICE_CODE_PENDING';
export const GET_DISUSE_DEVICE_CODE_FULFILLED = 'GET_DISUSE_DEVICE_CODE_FULFILLED';
export const GET_DISUSE_DEVICE_CODE_FAILURE = 'GET_DISUSE_DEVICE_CODE_FAILURE';

// 取得啟動碼列表
export const GET_DEVICE_CODE_LIST_PENDING = 'GET_DEVICE_CODE_LIST_PENDING';
export const GET_DEVICE_CODE_LIST_FULFILLED = 'GET_DEVICE_CODE_LIST_FULFILLED';
export const GET_DEVICE_CODE_LIST_FAILURE = 'GET_DEVICE_CODE_LIST_FAILURE';

// create a new device code
export const POST_CREATE_DEVICE_CODE_PENDING = 'POST_CREATE_DEVICE_CODE_PENDING';
export const POST_CREATE_DEVICE_CODE_FULFILLED = 'POST_CREATE_DEVICE_CODE_FULFILLED';
export const POST_CREATE_DEVICE_CODE_FAILURE = 'POST_CREATE_DEVICE_CODE_FAILURE';

// delete a device code
export const DELETE_DEVICE_CODE_PENDING = 'DELETE_DEVICE_CODE_PENDING';
export const DELETE_DEVICE_CODE_FULFILLED = 'DELETE_DEVICE_CODE_FULFILLED';
export const DELETE_DEVICE_CODE_FAILURE = 'DELETE_DEVICE_CODE_FAILURE';

// rename device code
export const UPDATE_DEVICE_CODE_NAME_PENDING = 'UPDATE_DEVICE_CODE_NAME_PENDING';
export const UPDATE_DEVICE_CODE_NAME_FULFILLED = 'UPDATE_DEVICE_CODE_NAME_FULFILLED';
export const UPDATE_DEVICE_CODE_NAME_FAILURE = 'UPDATE_DEVICE_CODE_NAME_FAILURE';

// -------------- booth device -------------------
// logut booth device code
export const GET_DISUSE_BOOTH_DEVICE_CODE_PENDING = 'GET_DISUSE_BOOTH_DEVICE_CODE_PENDING';
export const GET_DISUSE_BOOTH_DEVICE_CODE_FULFILLED = 'GET_DISUSE_BOOTH_DEVICE_CODE_FULFILLED';
export const GET_DISUSE_BOOTH_DEVICE_CODE_FAILURE = 'GET_DISUSE_BOOTH_DEVICE_CODE_FAILURE';

// 取得活動啟動碼列表
export const GET_BOOTH_DEVICE_CODE_LIST_PENDING = 'GET_BOOTH_DEVICE_CODE_LIST_PENDING';
export const GET_BOOTH_DEVICE_CODE_LIST_FULFILLED = 'GET_BOOTH_DEVICE_CODE_LIST_FULFILLED';
export const GET_BOOTH_DEVICE_CODE_LIST_FAILURE = 'GET_BOOTH_DEVICE_CODE_LIST_FAILURE';

// create a new booth device code
export const POST_CREATE_BOOTH_DEVICE_CODE_PENDING = 'POST_CREATE_BOOTH_DEVICE_CODE_PENDING';
export const POST_CREATE_BOOTH_DEVICE_CODE_FULFILLED = 'POST_CREATE_BOOTH_DEVICE_CODE_FULFILLED';
export const POST_CREATE_BOOTH_DEVICE_CODE_FAILURE = 'POST_CREATE_BOOTH_DEVICE_CODE_FAILURE';

// delete a booth device code
export const DELETE_BOOTH_DEVICE_CODE_PENDING = 'DELETE_BOOTH_DEVICE_CODE_PENDING';
export const DELETE_BOOTH_DEVICE_CODE_FULFILLED = 'DELETE_BOOTH_DEVICE_CODE_FULFILLED';
export const DELETE_BOOTH_DEVICE_CODE_FAILURE = 'DELETE_BOOTH_DEVICE_CODE_FAILURE';

// rename booth device code
export const UPDATE_BOOTH_DEVICE_CODE_NAME_PENDING = 'UPDATE_BOOTH_DEVICE_CODE_NAME_PENDING';
export const UPDATE_BOOTH_DEVICE_CODE_NAME_FULFILLED = 'UPDATE_BOOTH_DEVICE_CODE_NAME_FULFILLED';
export const UPDATE_BOOTH_DEVICE_CODE_NAME_FAILURE = 'UPDATE_BOOTH_DEVICE_CODE_NAME_FAILURE';

// -------------- Profile ---------------
export const GET_PROFILE_PENDING = 'GET_PROFILE_PENDING';
export const GET_PROFILE_FULFILLED = 'GET_PROFILE_FULFILLED';
export const GET_PROFILE_FAILURE = 'GET_PROFILE_FAILURE';

// 更新 Profile
export const UPDATE_PROFILE_PENDING = 'UPDATE_PROFILE_PENDING';
export const UPDATE_PROFILE_FULFILLED = 'UPDATE_PROFILE_FULFILLED';
export const UPDATE_PROFILE_FAILURE = 'UPDATE_PROFILE_FAILURE';

// -------------- List ---------------
// delete a user row in list
export const DELETE_SINGLE_ROW_IN_USER_LIST_PENDING = 'DELETE_SINGLE_ROW_IN_USER_LIST_PENDING';
export const DELETE_SINGLE_ROW_IN_USER_LIST_FULFILLED = 'DELETE_SINGLE_ROW_IN_USER_LIST_FULFILLED';
export const DELETE_SINGLE_ROW_IN_USER_LIST_FAILURE = 'DELETE_SINGLE_ROW_IN_USER_LIST_FAILURE';

// delete all user rows in lsit
export const DELETE_ALL_ROWS_IN_USER_LIST_PENDING = 'DELETE_ALL_ROWS_IN_USER_LIST_PENDING';
export const DELETE_ALL_ROWS_IN_USER_LIST_FULFILLED = 'DELETE_ALL_ROWS_IN_USER_LIST_FULFILLED';
export const DELETE_ALL_ROWS_IN_USER_LIST_FAILURE = 'DELETE_ALL_ROWS_IN_USER_LIST_FAILURE';

// -------------- EMAIL TEMPLATES ---------------
// GET email templates
export const GET_EMAIL_TEMPLATES_PENDING = 'GET_EMAIL_TEMPLATES_PENDING';
export const GET_EMAIL_TEMPLATES_FULFILLED = 'GET_EMAIL_TEMPLATES_FULFILLED';
export const GET_EMAIL_TEMPLATES_FAILURE = 'GET_EMAIL_TEMPLATES_FAILURE';

// POST email template
export const POST_EMAIL_TEMPLATE_PENDING = 'POST_EMAIL_TEMPLATE_PENDING';
export const POST_EMAIL_TEMPLATE_FULFILLED = 'POST_EMAIL_TEMPLATE_FULFILLED';
export const POST_EMAIL_TEMPLATE_FAILURE = 'POST_EMAIL_TEMPLATE_FAILURE';

// DELETE email template
export const DELETE_EMAIL_TEMPLATE_PENDING = 'DELETE_EMAIL_TEMPLATE_PENDING';
export const DELETE_EMAIL_TEMPLATE_FULFILLED = 'DELETE_EMAIL_TEMPLATE_FULFILLED';
export const DELETE_EMAIL_TEMPLATE_FAILURE = 'DELETE_EMAIL_TEMPLATE_FAILURE';

// PATCH email template
export const PATCH_EMAIL_TEMPLATE_PENDING = 'PATCH_EMAIL_TEMPLATE_PENDING';
export const PATCH_EMAIL_TEMPLATE_FULFILLED = 'PATCH_EMAIL_TEMPLATE_FULFILLED';
export const PATCH_EMAIL_TEMPLATE_FAILURE = 'PATCH_EMAIL_TEMPLATE_FAILURE';

// -------------- EMAIL LIST ---------------
// TODO: 應該都改叫 draft，然後 get email list 刪掉和 get email draft 共用
// GET email list
export const GET_EMAIL_LIST_PENDING = 'GET_EMAIL_LIST_PENDING';
export const GET_EMAIL_LIST_FULFILLED = 'GET_EMAIL_LIST_FULFILLED';
export const GET_EMAIL_LIST_FAILURE = 'GET_EMAIL_LIST_FAILURE';

// GET email draft
export const GET_EMAIL_DRAFT_PEDNING = 'GET_EMAIL_DRAFT_PEDNING';
export const GET_EMAIL_DRAFT_FULFILLED = 'GET_EMAIL_DRAFT_FULFILLED';
export const GET_EMAIL_DRAFT_FAILURE = 'GET_EMAIL_DRAFT_FAILURE';

// POST email list
export const POST_EMAIL_LIST_PENDING = 'POST_EMAIL_LIST_PENDING';
export const POST_EMAIL_LIST_FULFILLED = 'POST_EMAIL_LIST_FULFILLED';
export const POST_EMAIL_LIST_FAILURE = 'POST_EMAIL_LIST_FAILURE';

// DELETE email list
export const DELETE_EMAIL_LIST_PENDING = 'DELETE_EMAIL_LIST_PENDING';
export const DELETE_EMAIL_LIST_FULFILLED = 'DELETE_EMAIL_LIST_FULFILLED';
export const DELETE_EMAIL_LIST_FAILURE = 'DELETE_EMAIL_LIST_FAILURE';

// PATCH email list
export const PATCH_EMAIL_LIST_PENDING = 'PATCH_EMAIL_LIST_PENDING';
export const PATCH_EMAIL_LIST_FULFILLED = 'PATCH_EMAIL_LIST_FULFILLED';
export const PATCH_EMAIL_LIST_FAILURE = 'PATCH_EMAIL_LIST_FAILURE';

// POST copy email list
export const POST_COPY_EMAIL_LIST_PENDING = 'POST_COPY_EMAIL_LIST_PENDING';
export const POST_COPY_EMAIL_LIST_FULFILLED = 'POST_COPY_EMAIL_LIST_FULFILLED';
export const POST_COPY_EMAIL_LIST_FAILURE = 'POST_COPY_EMAIL_LIST_FAILURE';

// CHECK email list 有沒有特定參加者 getIsParticularAttendeeInEmailList
export const GET_PARTICULAR_ATTENDEE_NUMBER_PENDING = 'GET_PARTICULAR_ATTENDEE_NUMBER_PENDING';
export const GET_PARTICULAR_ATTENDEE_NUMBER_FULFILLED = 'GET_PARTICULAR_ATTENDEE_NUMBER_FULFILLED';
export const GET_PARTICULAR_ATTENDEE_NUMBER_FAILURE = 'GET_PARTICULAR_ATTENDEE_NUMBER_FAILURE';

// get email preview
export const GET_EMAIL_PREVIEW_PENDING = 'GET_EMAIL_PREVIEW_PENDING';
export const GET_EMAIL_PREVIEW_FULFILLED = 'GET_EMAIL_PREVIEW_FULFILLED';
export const GET_EMAIL_PREVIEW_FAILURE = 'GET_EMAIL_PREVIEW_FAILURE';

// -------------  email record -----------
// GET Single Email record
export const GET_SINGLE_EMAIL_RECORD_PENDING = 'GET_SINGLE_EMAIL_RECORD_PENDING';
export const GET_SINGLE_EMAIL_RECORD_FULFILLED = 'GET_SINGLE_EMAIL_RECORD_FULFILLED';
export const GET_SINGLE_EMAIL_RECORD_FAILURE = 'GET_SINGLE_EMAIL_RECORD_FAILURE';

// -------------- SMS draft ---------------
// GET SMS list
export const GET_SMS_LIST_PENDING = 'GET_SMS_LIST_PENDING';
export const GET_SMS_LIST_FULFILLED = 'GET_SMS_LIST_FULFILLED';
export const GET_SMS_LIST_FAILURE = 'GET_SMS_LIST_FAILURE';

// GET SMS draft
export const GET_SMS_DRAFT_PENDING = 'GET_SMS_DRAFT_PENDING';
export const GET_SMS_DRAFT_FULFILLED = 'GET_SMS_DRAFT_FULFILLED';
export const GET_SMS_DRAFT_FAILURE = 'GET_SMS_DRAFT_FAILURE';

// POST SMS draft
export const POST_SMS_DRAFT_PENDING = 'POST_SMS_DRAFT_PENDING';
export const POST_SMS_DRAFT_FULFILLED = 'POST_SMS_DRAFT_FULFILLED';
export const POST_SMS_DRAFT_FAILURE = 'POST_SMS_DRAFT_FAILURE';

// POST copy draft
export const POST_COPY_SMS_DRAFT_PENDING = 'POST_COPY_SMS_DRAFT_PENDING';
export const POST_COPY_SMS_DRAFT_FULFILLED = 'POST_COPY_SMS_DRAFT_FULFILLED';
export const POST_COPY_SMS_DRAFT_FAILURE = 'POST_COPY_SMS_DRAFT_FAILURE';

// DELETE SMS draft
export const DELETE_SMS_DRAFT_PEDNING = 'DELETE_SMS_DRAFT_PEDNING';
export const DELETE_SMS_DRAFT_FULFILLED = 'DELETE_SMS_DRAFT_FULFILLED';
export const DELETE_SMS_DRAFT_FAILURE = 'DELETE_SMS_DRAFT_FAILURE';

// PATCH SMS draft
export const PATCH_SMS_DRAFT_PENDING = 'PATCH_SMS_DRAFT_PENDING';
export const PATCH_SMS_DRAFT_FULFILLED = 'PATCH_SMS_DRAFT_FULFILLED';
export const PATCH_SMS_DRAFT_FAILURE = 'PATCH_SMS_DRAFT_FAILURE';

// GET SMS record
export const GET_SINGLE_SMS_RECORD_PENDING = 'GET_SINGLE_SMS_RECORD_PENDING';
export const GET_SINGLE_SMS_RECORD_FULFILLED = 'GET_SINGLE_SMS_RECORD_FULFILLED';
export const GET_SINGLE_SMS_RECORD_FAILURE = 'GET_SINGLE_SMS_RECORD_FAILURE';

// GET SMS preview
export const GET_SMS_PREVIEW_PENDING = 'GET_SMS_PREVIEW_PENDING';
export const GET_SMS_PREVIEW_FULFILLED = 'GET_SMS_PREVIEW_FULFILLED';
export const GET_SMS_PREVIEW_FAILURE = 'GET_SMS_PREVIEW_FAILURE';

// POST sms content to get sms preview in sms editing
export const POST_CONTENT_TO_GET_SMS_PREVIEW_PENDING = 'POST_CONTENT_TO_GET_SMS_PREVIEW_PENDING';
export const POST_CONTENT_TO_GET_SMS_PREVIEW_FULFILLED =
  'POST_CONTENT_TO_GET_SMS_PREVIEW_FULFILLED';
export const POST_CONTENT_TO_GET_SMS_PREVIEW_FAILURE = 'POST_CONTENT_TO_GET_SMS_PREVIEW_FAILURE';

// POST content to get real cost
export const POST_CONTENT_TO_GET_REAL_COST_PENDING = 'POST_CONTENT_TO_GET_REAL_COST_PENDING';
export const POST_CONTENT_TO_GET_REAL_COST_FULFILLED = 'POST_CONTENT_TO_GET_REAL_COST_FULFILLED';
export const POST_CONTENT_TO_GET_REAL_COST_FAILURE = 'POST_CONTENT_TO_GET_REAL_COST_FAILURE';

// ----------- Health Form ------------
export const GET_HEALTH_FORM_TEMPLATES_PENDING = 'GET_HEALTH_FORM_TEMPLATES_PENDING';
export const GET_HEALTH_FORM_TEMPLATES_FULFILLED = 'GET_HEALTH_FORM_TEMPLATES_FULFILLED';
export const GET_HEALTH_FORM_TEMPLATES_FAILURE = 'GET_HEALTH_FORM_TEMPLATES_FAILURE';

export const GET_HEALTH_FORM_SETTING_PENDING = 'GET_HEALTH_FORM_SETTING_PENDING';
export const GET_HEALTH_FORM_SETTING_FULFILLED = 'GET_HEALTH_FORM_SETTING_FULFILLED';
export const GET_HEALTH_FORM_SETTING_FAILURE = 'GET_HEALTH_FORM_SETTING_FAILURE';

export const PATCH_HEALTH_FORM_SETTING_PENDING = 'PATCH_HEALTH_FORM_SETTING_PENDING';
export const PATCH_HEALTH_FORM_SETTING_FULFILLED = 'PATCH_HEALTH_FORM_SETTING_FULFILLED';
export const PATCH_HEALTH_FORM_SETTING_FAILURE = 'PATCH_HEALTH_FORM_SETTING_FAILURE';

// -------------- POINT ---------------
export const SET_TOTAL_POINT = 'SET_TOTAL_POINT';

// -------------- CHECKIN QUOTA ---------------
export const SET_CHECKIN_QUOTA = 'SET_CHECKIN_QUOTA';

// ------------ File ---------------
export const POST_FILE_UPLOAD_PENDING = 'POST_FILE_UPLOAD_PENDING';
export const POST_FILE_UPLOAD_FULFILLED = 'POST_FILE_UPLOAD_FULFILLED';
export const POST_FILE_UPLOAD_FAILURE = 'POST_FILE_UPLOAD_FAILURE';

// ---------- index page ---------------
export const GET_INDEX_PAGE_EDIT_PENDING = 'GET_INDEX_PAGE_EDIT_PENDING';
export const GET_INDEX_PAGE_EDIT_FULFILLED = 'GET_INDEX_PAGE_EDIT_FULFILLED';
export const GET_INDEX_PAGE_EDIT_FAILURE = 'GET_INDEX_PAGE_EDIT_FAILURE';

export const POST_INDEX_PAGE_PENDING = 'POST_INDEX_PAGE_PENDING';
export const POST_INDEX_PAGE_FULFILLED = 'POST_INDEX_PAGE_FULFILLED';
export const POST_INDEX_PAGE_FAILURE = 'POST_INDEX_PAGE_FAILURE';

export const PATCH_INDEX_PAGE_EDIT_PENDING = 'PATCH_INDEX_PAGE_EDIT_PENDING';
export const PATCH_INDEX_PAGE_EDIT_FULFILLED = 'PATCH_INDEX_PAGE_EDIT_FULFILLED';
export const PATCH_INDEX_PAGE_EDIT_FAILURE = 'PATCH_INDEX_PAGE_EDIT_FAILURE';

export const GET_GUEST_INDEX_PAGE_PENDING = 'GET_GUEST_INDEX_PAGE_PENDING';
export const GET_GUEST_INDEX_PAGE_FULFILLED = 'GET_GUEST_INDEX_PAGE_FULFILLED';
export const GET_GUEST_INDEX_PAGE_FAILURE = 'GET_GUEST_INDEX_PAGE_FAILURE';

export const GET_INDEX_PAGE_PREVIEW_PENDING = 'GET_INDEX_PAGE_PREVIEW_PENDING';
export const GET_INDEX_PAGE_PREVIEW_FULFILLED = 'GET_INDEX_PAGE_PREVIEW_FULFILLED';
export const GET_INDEX_PAGE_PREVIEW_FAILURE = 'GET_INDEX_PAGE_PREVIEW_FAILURE';

// --------------- Badge ---------------
export const GET_BADGE_SETTING_PENDING = 'GET_BADGE_SETTING_PENDING';
export const GET_BADGE_SETTING_FULFILLED = 'GET_BADGE_SETTING_FULFILLED';
export const GET_BADGE_SETTING_FAILURE = 'GET_BADGE_SETTING_FAILURE';

export const POST_BADGE_SETTING_PENDGING = 'POST_BADGE_SETTING_PENDGING';
export const POST_BADGE_SETTING_FULFILLED = 'POST_BADGE_SETTING_FULFILLED';
export const POST_BADGE_SETTING_FAILURE = 'POST_BADGE_SETTING_FAILURE';

export const DELETE_BADGE_SETTING_PENDING = 'DELETE_BADGE_SETTING_PENDING';
export const DELETE_BADGE_SETTING_FULFILLED = 'DELETE_BADGE_SETTING_FULFILLED';
export const DELETE_BADGE_SETTING_FAILURE = 'DELETE_BADGE_SETTING_FAILURE';

export const PATCH_BADGE_SETTING_PENDING = 'PATCH_BADGE_SETTING_PENDING';
export const PATCH_BADGE_SETTING_FULFILLED = 'PATCH_BADGE_SETTING_FULFILLED';
export const PATCH_BADGE_SETTING_FAILURE = 'PATCH_BADGE_SETTING_FAILURE';

// ------------- system announcement -----------
// GET All announcements
export const GET_SYSTEM_ANNOUNCEMENTS_PENDING = 'GET_SYSTEM_ANNOUNCEMENTS_PENDING';
export const GET_SYSTEM_ANNOUNCEMENTS_FULFILLED = 'GET_SYSTEM_ANNOUNCEMENTS_FULFILLED';
export const GET_SYSTEM_ANNOUNCEMENTS_FAILURE = 'GET_SYSTEM_ANNOUNCEMENTS_FAILURE';

// ---------- 統計、Dashboard -----------
// 參加者報到出席狀況
export const GET_ATTENDEE_CHECKIN_SITUATION_PENDING = 'GET_ATTENDEE_CHECKIN_SITUATION_PENDING';
export const GET_ATTENDEE_CHECKIN_SITUATION_FULFILLED = 'GET_ATTENDEE_CHECKIN_SITUATION_FULFILLED';
export const GET_ATTENDEE_CHECKIN_SITUATION_FAILURE = 'GET_ATTENDEE_CHECKIN_SITUATION_FAILURE';

// 匯出統計報表
export const POST_EXPORT_STATISTIC_CHECKIN_REPORT_PENDING =
  'POST_EXPORT_STATISTIC_CHECKIN_REPORT_PENDING';
export const POST_EXPORT_STATISTIC_CHECKIN_REPORT_FULFILLED =
  'POST_EXPORT_STATISTIC_CHECKIN_REPORT_FULFILLED';
export const POST_EXPORT_STATISTIC_CHECKIN_REPORT_FAILURE =
  'POST_EXPORT_STATISTIC_CHECKIN_REPORT_FAILURE';

// 取得自訂圖表 list
export const GET_CUSTOMIZE_CHART_LIST_PENDING = 'GET_CUSTOMIZE_CHART_LIST_PENDING';
export const GET_CUSTOMIZE_CHART_LIST_FULFILLED = 'GET_CUSTOMIZE_CHART_LIST_FULFILLED';
export const GET_CUSTOMIZE_CHART_LIST_FAILURE = 'GET_CUSTOMIZE_CHART_LIST_FAILURE';

// 新增一自訂圖表到 chart lsit
export const POST_SINGLE_CUSTOMIZE_CHART_PENDING = 'POST_SINGLE_CUSTOMIZE_CHART_PENDING';
export const POST_SINGLE_CUSTOMIZE_CHART_FULFILLED = 'POST_SINGLE_CUSTOMIZE_CHART_FULFILLED';
export const POST_SINGLE_CUSTOMIZE_CHART_FAILURE = 'POST_SINGLE_CUSTOMIZE_CHART_FAILURE';

// 刪除一自訂圖表從 chart list
export const DELETE_SINGLE_CUSTOMIZE_CHART_PENDING = 'DELETE_SINGLE_CUSTOMIZE_CHART_PENDING';
export const DELETE_SINGLE_CUSTOMIZE_CHART_FULFILLED = 'DELETE_SINGLE_CUSTOMIZE_CHART_FULFILLED';
export const DELETE_SINGLE_CUSTOMIZE_CHART_FAILURE = 'DELETE_SINGLE_CUSTOMIZE_CHART_FAILURE';

// ------------------------ client -------------------------
export const SET_GUEST_SIGN_UP_INFO = 'SET_GUEST_SIGN_UP_INFO';
export const SET_GUEST_SELECT_SESSIONS = 'SET_GUEST_SELECT_SESSIONS';
